import React, { FC } from 'react';

import { Accordion } from '@chakra-ui/react';

import { ResourceActionsPatternAccordion } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/ResourceActionsPatternAccordion';
import { ResourceAccessPatternAccordion } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Access/ResourceAccessPatternAccordion';

export const IAMRoleActivity: FC = () => {
  return (
    <Accordion allowMultiple defaultIndex={[0]}>
      <ResourceAccessPatternAccordion />
      <ResourceActionsPatternAccordion />
    </Accordion>
  );
};
